import { Component, OnInit } from '@angular/core';
import { inductryMaster } from '../../../Models/InductryMasterModel';
import { CheckAuth } from '../../../Services/UtilityService';
import { AdminInductryMasterServices } from '../../../Services/Admin/InductryMaster';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

// import { Observable, Subscription, timer } from 'rxjs';
// import { timeInterval, pluck, take } from 'rxjs/operator';

@Component({
  selector: 'app-manage-industry-list',
  templateUrl: './manage-industry-list.component.html',
  styleUrls: ['./manage-industry-list.component.css']
})
export class ManageIndustryListComponent implements OnInit {
  tokenKey: string = '';
  inductryMaster: inductryMaster[] = [];
  statusCode: number = 0;
  totalPageSize: number = 0;
  pageSize: number = 0;
  pageIndex: number = 0;
  orderBy: string = 'null';
  whereCondition: string = 'null';
  deleteId: string = '0';
  isAscending: boolean;
  refreshTable: boolean = true;
  upDowInductryNameCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowDisplayOrderCSS: string = '';
  // Message 
  isErrorMessage: boolean = false;
  errorMessage: string = '';
  // private timer: Observable<any>;

  constructor(private toastr: ToastrService, private checkAuth: CheckAuth, private inductryServices: AdminInductryMasterServices, private router: Router) {
    this.tokenKey = sessionStorage.getItem('tokenValue');
    this.tokenExpireCalculation(sessionStorage.getItem('appStartTime'), sessionStorage.getItem('tokenExpiryValue'));

  }

  ngOnInit() {
    this.refreshTable = true;
    this.pageSize = 10;
    this.totalPageSize = 1;
    this.pageIndex = 1;
    this.whereCondition = 'null';
    this.orderBy = 'DisplayOrder DESC';
    this.isAscending = false;
    this.GetInductryMaster();
    this.showErrorMessage();
  }

  showErrorMessage() {
    debugger;
    if (sessionStorage.getItem("IndustryCRUDStatus") !== null) {
      if (sessionStorage.getItem("IndustryCRUDStatus") === 'Added') {
        this.showMessage('Industry added successfully', 'Added', 'success');
        sessionStorage.removeItem('IndustryCRUDStatus');
      }
      else if (sessionStorage.getItem("IndustryCRUDStatus") === 'Edited') {
        this.showMessage('Industry updated successfully', 'Edited', 'success');
        sessionStorage.removeItem('IndustryCRUDStatus');
      }
    }
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  GetInductryMaster(): void {
    this.inductryServices.GetInductryMasterFilterByPage(this.tokenKey, this.pageIndex.toString(), this.pageSize.toString(), this.whereCondition, this.orderBy).subscribe(
      data => {
        debugger;
        this.inductryMaster = data["inductry"];
        if (this.inductryMaster.length > 0)
          this.totalPageSize = parseInt(this.inductryMaster[0].totalRecords);
      },
      error => this.statusCode = error,
    );
  }

  pageChanged($event) {
    this.pageIndex = parseInt($event.page);
    this.GetInductryMaster();
  }

  setInductryId(Id: string) {
    this.deleteId = Id;
  }

  editIndustry(id: string) {
    debugger;
    let navigation = '/admin/industry/edit/' + id;
    this.router.navigate([navigation]);
  }

  sort(sortBy: string) {
    debugger;

    if (!this.isAscending) {
      this.isAscending = true;
      this.orderBy = sortBy + ' DESC';

      if (sortBy === "InductryName") {
        this.upDowInductryNameCSS = 'fa fa-arrow-up';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowInductryNameCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "DisplayOrder") {
        this.upDowInductryNameCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = 'fa fa-arrow-up';
      }
    }
    else {
      this.isAscending = false;
      this.orderBy = sortBy;

      if (sortBy === "InductryName") {
        this.upDowInductryNameCSS = 'fa fa-arrow-down';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "IsActive") {
        this.upDowInductryNameCSS = '';
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
        this.upDowDisplayOrderCSS = '';
      }
      else if (sortBy === "DisplayOrder") {
        this.upDowInductryNameCSS = '';
        this.upDowIsActiveCSS = '';
        this.upDowDisplayOrderCSS = 'fa fa-arrow-down';
      }

    }

    this.GetInductryMaster();
  }

  deleteIndustry() {
    this.inductryServices.DeleteInductryMaster(this.tokenKey, this.deleteId).subscribe(
      data => {
        this.pageSize = 10;
        this.totalPageSize = 1;
        this.pageIndex = 1;
        this.whereCondition = 'null';
        this.orderBy = 'DisplayOrder DESC';
        this.isAscending = false;
        this.GetInductryMaster();
        this.refreshGrid();
        this.showMessage('Industry deleted successfully', 'Deleted', 'success');
      },
      error => this.statusCode = error,
    );
  }

  refreshGrid(): void {
    this.refreshTable = false;
    setTimeout(() => {
      this.refreshTable = true;
      this.pageIndex = 1;
    }, 10);
  }

}
